import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyB68uW-QMSxOzXrkgbv0RYGc645kVHwFhc",
  authDomain: "crm-loj.firebaseapp.com",
  projectId: "crm-loj",
  storageBucket: "crm-loj.appspot.com",
  messagingSenderId: "720229338459",
  appId: "1:720229338459:web:1cde71b4c76a5fabed9e7e",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const messaging = getMessaging(app);

export { app, db, messaging };
